// Itens do menu principal do site público (cabeçalho e menu mobile).
// Menu oculto temporariamente: "Contato" (spam no formulário de contato).
export default [
  { name: "Home", label: "Início" },
  { name: "Acordos e Convenções", label: "Acordos e convenções" },
  { name: "Notícias", label: "Notícias" },
  { name: "Galeria", label: "Galeria" },
  { name: "Clube", label: "Clube" },
  { name: "Convênios", label: "Convênios" },
];
